import React, { useState } from "react";
import { formValueSelector, reduxForm } from "redux-form";
import validate from "./validate";
import { sendGet } from "services/api";
import PageFormOne from "./PageFormOne";
import { useSelector } from "react-redux";
import PageFormTwo from "./PageFormTwo";
import PageFormThree from "./PageFormThree";
import PageFormFour from "./PageFormFour";
import PageFormFive from "./PageFormFive";
import PageFormSix from "./PageFormSix";
import PageFormSeven from "./PageFormSeven";
import PageFormEight from "./PageFormEight";

const emissionForm = ({ onSubmit, type, change }) => {
	const [page, setPage] = useState(1);
	const [formData, setFormData] = useState({});
	const [user, setUser] = useState(null);

	const previousPage = () => {
		setPage(page => Math.max(page - 1, 1));
	};

	const onFormOneSubmit = data => {
		change("loading", true);

		if (type) {
			const finalData = { ...formData, ...data };

			change("loading", true);

			onSubmit(finalData, p => {
				change("loading", false);
				setPage(p);
			});
		} else {
			sendGet(`/user/public/${data.document}`)
				.then(response => {
					return response.json();
				})
				.then(result => {
					change("loading", false);

					if (result?.model) {
						setUser(result.model);

						change("events", result.model.events || []);

						setFormData(prevData => ({ ...prevData, ...data }));
						setPage(2);
					}
				});
		}
	};

	const onFormTwoSubmit = () => {
		setPage(3);
	};

	const onFormThreeSubmit = data => {
		setFormData(prevData => ({ ...prevData, ...data }));
		setPage(4);
	};

	const onFormFourSubmit = data => {
		setFormData(prevData => ({ ...prevData, ...data }));
		setPage(5);
	};
	const onFormFiveSubmit = data => {
		setFormData(prevData => ({ ...prevData, ...data }));
		setPage(6);
	};
	const onFormSixSubmit = data => {
		setFormData(prevData => ({ ...prevData, ...data }));
		setPage(7);
	};

	const onFormSevenSubmit = data => {
		setFormData(prevData => ({ ...prevData, ...data }));
		setPage(8);
	};

	const onFormEightSubmit = data => {
		const finalData = { ...formData, ...data };

		change("loading", true);

		onSubmit(finalData, p => {
			change("loading", false);
			setPage(p);
		});
	};

	return (
		<div>
			{page === 1 && <PageFormOne onSubmit={onFormOneSubmit} />}
			{page === 2 && (
				<PageFormTwo onSubmit={onFormTwoSubmit} previousPage={previousPage} />
			)}
			{page === 3 && (
				<PageFormThree
					onSubmit={onFormThreeSubmit}
					previousPage={previousPage}
				/>
			)}
			{page === 4 && (
				<PageFormFour onSubmit={onFormFourSubmit} previousPage={previousPage} />
			)}
			{page === 5 && (
				<PageFormFive onSubmit={onFormFiveSubmit} previousPage={previousPage} />
			)}
			{page === 6 && (
				<PageFormSix onSubmit={onFormSixSubmit} previousPage={previousPage} />
			)}
			{page === 7 && (
				<PageFormSeven
					onSubmit={onFormSevenSubmit}
					previousPage={previousPage}
				/>
			)}
			{page === 8 && (
				<PageFormEight
					onSubmit={onFormEightSubmit}
					previousPage={previousPage}
				/>
			)}
		</div>
	);
};

export default reduxForm({
	form: "certificate_emission",
	validate
})(emissionForm);
